module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "showbar": _vm.showmenu_bar,
      "index": "5"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('title')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[0]),
      expression: "imglist[0]"
    }],
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticClass: "download_img",
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "download_title"
  }, [_vm._v(_vm._s(_vm.$t('title2')))]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text content_item_text1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text'))
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button2 button2_Andorid",
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=com.VRVIU.VrPlayer",
      "target": "_blank"
    }
  }, [_vm._v("Andorid")]), _vm._v(" "), _c('a', {
    staticClass: "button2 button2_iOS gray",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("iOS")]), _vm._v(" "), _c('a', {
    staticClass: "button2 button2_geer gray",
    attrs: {
      "href": "javascript:void(0)"
    }
  })]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-573285e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/download.vue
// module id = 92
// module chunks = 0